<template>
<v-list three-line class='mb-5' >
  <v-progress-linear v-if='request.loading' class='ma-0' indeterminate height='2' ></v-progress-linear >
  <template v-for='communication in communications' >
    <communication-list-item :item='communication' :key='communication.id' >
    </communication-list-item>
    <v-divider :key='`div-${communication.id}`' ></v-divider>
  </template>
  <v-list-tile dense v-if='!request.loading && communications.length === 0' >
    <v-list-tile-content>
      <v-list-tile-title>
        No communications found for this invoice
      </v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</v-list>
</template>
<script>
import CommunicationListItem from '@/components/listitems/CommunicationListItem'

export default {
  name: 'InvoiceCommunications',
  components: {CommunicationListItem},
  props: {
    invoiceId: { required: true },
    touch: { type: Number, default: 0 },
    reqId: { type: String, default: 'communication-invoice-id' }
  },
  watch: {
    invoiceId: {
      immediate: true,
      handler () {
        this.fetch()
      }
    },
    touch () {
      this.fetch()
    }
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    communications () {
      return this.getObjectPath(this.request, 'result.data.results', [])
    }
  },
  methods: {
    fetch () {
      let params = {
        objects_invoice: this.invoiceId
      }
      this.$communicationguru
          .resource('communication')
          .id(this.reqId)
          .list(params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// InvoiceCommunications.vue?ef53633a